import { forwardRef } from 'react'
import classNames from 'classnames'
import type { ComponentPropsWithRef } from 'react'
import type { CommonProps } from '../@types/common'

export interface TdProps extends ComponentPropsWithRef<'td'>, CommonProps {}

const Td = forwardRef<HTMLTableCellElement, TdProps>((props, ref) => {
    const { children, className, ...rest } = props

    const tdClass = classNames(className)

    return (
        <td ref={ref} className={tdClass} {...rest}>
            {children}
        </td>
    )
})

Td.displayName = 'Td'

export default Td 